import useSWR from 'swr';
import { fetcher } from '../../../services/fetcher';

// API endpoints
const API_LIST = '/p-crm-priority';
const API_DETAIL = (id: number) => `/p-crm-priority/${id}`;

export interface Priority {
  id: number;
  p_descr?: string;
}

export const usePrioritys = (searchParams?: string) => {
  const queryString = searchParams ? `?searchParams=${encodeURIComponent(searchParams)}` : '';
  const { data, error, isLoading, mutate } = useSWR<Priority[]>(
    `${API_LIST}${queryString}`,
    fetcher,
    {
      revalidateOnFocus: true,
      revalidateOnReconnect: true,
    }
  );

  return {
    data: data || [],
    prioritys: data || [],
    isLoading,
    isError: error,
    mutate,
  };
};

export const usePriority = (id: number) => {
  const { data, error, isLoading, mutate } = useSWR<Priority>(
    id ? API_DETAIL(id) : null,
    fetcher,
    {
      revalidateOnFocus: true,
    }
  );

  return {
    data: data,
    priority: data,
    isLoading,
    isError: error,
    mutate,
  };
};
